import React, { useEffect } from "react";
import styles from "../LPSForm.styles";
import {
  AppBar,
  Box,
  Button, FormControl,
  IconButton,
  MenuItem,
  Toolbar,
  Typography
} from '@mui/material';
import DeleteIcon from "@mui/icons-material/Delete";
import StyledTextField from "../../../common/components/styled-components/StyledTextField";
import { Add } from "@mui/icons-material";
import { lpsFormTypes } from "../../../common/constants/field-constants";
import { handlePaste } from "../../../common/components/helpers/handlePaste";
import { Variable } from "../../../common/components/helpers/validator";
import { StyledInputLabel, StyledSelect } from '../../../common/components/styled-components/StyledSelect';
import { SelectChangeEvent } from '@mui/material/Select';

const objectVariableOptions = [
  {
    value: "units amount",
    label: "units amount",
  },
  {
    value: "non housing units",
    label: "non housing units",
  },
  {
    value: "built year",
    label: "built year",
  },
  {
    value: "owners amount",
    label: "owners amount",
  },
  {
    value: "WOZ-value",
    label: "WOZ-value",
  },
];

const objectConditionOptions = [
  {
    value: "bigger than",
    label: "bigger than",
  },
  {
    value: "equal",
    label: "equal",
  },
  {
    value: "less than",
    label: "less than",
  },
];

const ObjectPointsBlock = ({
  onChange,
  objectPointsRules,
  calculationType,
  onAdd,
  onDelete,
  isFilledFields,
  changeFilledFields,
  isVariables,
  changeIsVariables,
 }) => {
  const rules = JSON.stringify(objectPointsRules);
  const variables = JSON.stringify(isVariables);
  useEffect(() => {
    let newVariables: Variable[] = [];
    if (objectPointsRules.length === 0) {
      return changeIsVariables(newVariables)
    }
    if (isFilledFields.isFilledFieldObjectConditionRulesVariable !== undefined) {

      objectPointsRules.map((rule: any, index: number) => {
        if (rule.variable === '' || rule.variable === undefined) {
           newVariables = [...newVariables, {id: index, value: false }];
        }
        if (!!rule.variable) {
           newVariables = [...newVariables, {id: index, value: true }];
        }
        return changeIsVariables(newVariables);
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rules, objectPointsRules, changeIsVariables]);

  useEffect(() => {
    if (isVariables.some((item: Variable) => item.value)) {
      changeFilledFields({...isFilledFields, isFilledFieldObjectConditionRulesVariable: true});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variables]);

  return (
    <>
      <AppBar position="relative" sx={styles.dataBoxSecond}>
        <Toolbar sx={styles.toolBarSecond}>
          <Typography component="div" sx={styles.headerContentSecond}>
            Object points condition
          </Typography>
          <Button
            disabled={objectPointsRules.length >= 5}
            onClick={() =>
              onAdd(
                "lpsc_object_condition_rules",
                "lpsc_object_condition_rules"
              )
            }
          >
            <Add sx={{ color: "white" }} />
          </Button>
        </Toolbar>
      </AppBar>
      <Box sx={styles.fieldHolderSecond}>
        {objectPointsRules.length > 0 &&
          objectPointsRules.map(
            (
              { variable, condition, condition_value, condition_points },
              index: number
            ) => (
              <Box sx={styles.fieldBlockSecond} key={index}>
                <FormControl
                  fullWidth
                  required={calculationType !== lpsFormTypes.KADASTER}
                  error={
                    (!!Object.keys(isFilledFields).length &&
                      isFilledFields.isFilledFieldObjectConditionRulesVariable !== undefined &&
                      isVariables[index]?.value === false )
                  }
                  margin="dense"
                >
                  <StyledInputLabel
                    id="select-variable-label"
                    htmlFor="select-variable-input"
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "1rem",
                      }
                    }}
                  >
                    Variable
                  </StyledInputLabel>
                  <StyledSelect
                    labelId="select-variable-label"
                    id="select-variable"
                    name="selectVariable"
                    value={variable || ""}
                    label="Variable"
                    onChange={(event: SelectChangeEvent) =>  onChange(
                      "object_points_condition_rules",
                      "variable",
                      event,
                      index
                    )}
                    sx={styles.inputTextField}
                    inputProps={{
                      id: 'select-variable-input',
                    }}
                  >
                    {objectVariableOptions.map((option) => {
                      return (
                        <MenuItem
                          key={option.value}
                          value={option.value}
                          disabled={variable === "units amount" ? true : option.value === "units amount"}
                        >
                          {option.label}
                        </MenuItem>
                      )})}
                  </StyledSelect>
                </FormControl>
                {/*<StyledTextField*/}
                {/*  fullWidth*/}
                {/*  error={*/}
                {/*    (!!Object.keys(isFilledFields).length &&*/}
                {/*     isFilledFields.isFilledFieldObjectConditionRulesVariable !== undefined &&*/}
                {/*    isVariables[index]?.value === false )*/}
                {/*    // ||*/}
                {/*    // (!!Object.keys(isFilledFields).length &&*/}
                {/*    //  isFilledFields.isFilledFieldObjectConditionRulesVariable !== undefined &&*/}
                {/*    //  !objectPointsRules.some((item) => item.variable === "units amount")*/}
                {/*    // )*/}
                {/*  }*/}
                {/*  required={calculationType !== lpsFormTypes.KADASTER}*/}
                {/*  select*/}
                {/*  label="Variable"*/}
                {/*  sx={styles.inputTextField}*/}
                {/*  slotProps={{*/}
                {/*    inputLabel: {*/}
                {/*      sx: {*/}
                {/*        fontSize: {*/}
                {/*          xs: "12px",*/}
                {/*          sm: "14px",*/}
                {/*          md: "1rem",*/}
                {/*        },*/}
                {/*      },*/}
                {/*    },*/}
                {/*  }}*/}
                {/*  margin="dense"*/}
                {/*  defaultValue="units amount"*/}
                {/*  onChange={(e) =>*/}
                {/*    onChange(*/}
                {/*      "object_points_condition_rules",*/}
                {/*      "variable",*/}
                {/*      e,*/}
                {/*      index*/}
                {/*    )*/}
                {/*  }*/}
                {/*  value={variable || ""}*/}
                {/*>*/}
                {/*  {objectVariableOptions.map((option) => {*/}
                {/*   return (*/}
                {/*    <MenuItem*/}
                {/*      key={option.value}*/}
                {/*      value={option.value}*/}
                {/*      disabled={variable === "units amount" ? true : option.value === "units amount"}*/}
                {/*    >*/}
                {/*      {option.label}*/}
                {/*    </MenuItem>*/}
                {/*  )})}*/}
                {/*</StyledTextField>*/}
                <FormControl
                  fullWidth
                  margin="dense"
                >
                  <StyledInputLabel
                    id="select-condition-label"
                    htmlFor="select-condition-input"
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "1rem",
                      }
                    }}
                  >
                    Condition
                  </StyledInputLabel>
                  <StyledSelect
                    labelId="select-condition-label"
                    id="select-condition"
                    name="selectCondition"
                    value={condition || ""}
                    label="Condition"
                    onChange={(event: SelectChangeEvent) =>  onChange(
                      "object_points_condition_rules",
                      "condition",
                      event,
                      index
                    )}
                    sx={styles.inputTextField}
                    inputProps={{
                      id: 'select-condition-input',
                    }}
                  >
                    {objectConditionOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </StyledSelect>
                </FormControl>
                {/*<StyledTextField*/}
                {/*  fullWidth*/}
                {/*  select*/}
                {/*  label="Condition"*/}
                {/*  sx={styles.inputTextField}*/}
                {/*  slotProps={{*/}
                {/*    inputLabel: {*/}
                {/*      sx: {*/}
                {/*        fontSize: {*/}
                {/*          xs: "12px",*/}
                {/*          sm: "14px",*/}
                {/*          md: "1rem",*/}
                {/*        },*/}
                {/*      },*/}
                {/*    },*/}
                {/*  }}*/}
                {/*  margin="dense"*/}
                {/*  onChange={(e) =>*/}
                {/*    onChange(*/}
                {/*      "object_points_condition_rules",*/}
                {/*      "condition",*/}
                {/*      e,*/}
                {/*      index*/}
                {/*    )*/}
                {/*  }*/}
                {/*  value={condition || ""}*/}
                {/*>*/}
                {/*  {objectConditionOptions.map((option) => (*/}
                {/*    <MenuItem key={option.value} value={option.value}>*/}
                {/*      {option.label}*/}
                {/*    </MenuItem>*/}
                {/*  ))}*/}
                {/*</StyledTextField>*/}
                <StyledTextField
                  fullWidth
                  label="Value"
                  sx={styles.inputTextField}
                  slotProps={{
                    inputLabel: {
                      sx: {
                        fontSize: {
                          xs: "12px",
                          sm: "14px",
                          md: "1rem",
                        },
                      },
                    },
                    htmlInput: {
                      min: 0,
                      pattern: "[0-9]*"
                    },
                  }}
                  margin="dense"
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "e" || e.key === "E" || e.key === "-" || e.key === "+" || e.key === "." || e.key === ",") {
                      e.preventDefault()
                    }
                  }}
                  onChange={(e) =>
                    onChange(
                      "object_points_condition_rules",
                      "condition_value",
                      e,
                      index
                    )
                  }
                  onPaste={handlePaste}
                  value={condition_value ? condition_value : ''}
                />
                <StyledTextField
                  fullWidth
                  label="Points"
                  sx={styles.inputTextField}
                  slotProps={{
                    inputLabel: {
                      sx: {
                        fontSize: {
                          xs: "12px",
                          sm: "14px",
                          md: "1rem",
                        },
                      },
                    },
                    htmlInput: {
                      min: 0,
                      pattern: "[0-9]*"
                    }

                  }}
                  margin="dense"
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "e" || e.key === "E" || e.key === "-" || e.key === "+") {
                      e.preventDefault()
                    }
                  }}
                  onChange={(e) =>
                    onChange(
                      "object_points_condition_rules",
                      "condition_points",
                      e,
                      index
                    )
                  }
                  onPaste={handlePaste}
                  value={condition_points ? condition_points : ''}
                />
                <IconButton
                  sx={{
                    color: "#B4CEE5",
                    fontSize: {
                      xs: "medium",
                      sm: "medium",
                      md: "24px",
                    },
                  }}
                  disabled = {variable === "units amount"}
                  onClick={() =>
                    onDelete(
                      "lpsc_object_condition_rules",
                      "lpsc_object_condition_rules",
                      index
                    )
                  }
                  aria-label="Delete"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            )
          )}
      </Box>
    </>
  );
};

export default ObjectPointsBlock;
